import Suspense from "components/shared/Suspense";
import useMount from "hooks/useMount";
import useIsLoggedIn from "hooks/user/useIsLoggedIn";
import { lazy } from "react";
import { PageSerializersAuthorsLayout } from "types/serializers";

const ReportAuthorContent = lazy(() => import("./ReportAuthorContent"));

export default function ReportAuthorButton({ author }: { author: PageSerializersAuthorsLayout }) {
  const isLoggedIn = useIsLoggedIn();
  const mounted = useMount();

  if (!mounted || !isLoggedIn) {
    return <></>;
  }

  return (
    <Suspense>
      <ReportAuthorContent author={author} />
    </Suspense>
  );
}
